export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"m4.8 12 4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm14.4 0-4.6-4.6L16 6l6 6-6 6-1.4-1.4z\"/>"
};